import React, { ReactNode, forwardRef } from 'react'

import classNames from 'classnames'

interface Props {
  height?: string | number
  isPageType?: boolean
  isTransparentBg?: boolean
  children?: ReactNode
  isBottomSheet?: boolean
}

const Loading: React.ForwardRefRenderFunction<HTMLDivElement, Props> = (
  { height = 50, isPageType = false, isTransparentBg = false, children, isBottomSheet },
  ref,
) => {
  return (
    <div
      ref={ref}
      className={classNames('place_load_area_wrapper', {
        type_page: isPageType,
        type_transparent_bg: isTransparentBg,
        type_bottom_sheet: isBottomSheet,
      })}
      style={isPageType ? {} : { height }}
    >
      <span className="place_blind">로딩중</span>
      <div className="place_load_area">
        <div className="dot dot1" />
        <div className="dot dot2" />
        <div className="dot dot3" />
        <div className="dot dot4" />
        <div className="dot dot5" />
        <div className="dot dot6" />
      </div>
      {children}
    </div>
  )
}
export default forwardRef<HTMLDivElement, Props>(Loading)
